import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a09ac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Imágenes filtradas: ")
const _hoisted_7 = { style: {"color":"#409eff"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Aplicar")

import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import { getSamplingPointsNoRelations } from "@/service/samplingpoint.service";
import { CameraConfiguration } from "@/types/cameraconfiguration.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { computed, nextTick, onBeforeMount, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { Filter } from "@/types/station.type";
import { getTmoa } from "@/service/tmoa.service";

import ImagesLabelGallery from "@/components/processTracking/imageLabel/imageLabelGallery.component";
import ImagesLabelGalleryMultiple from "@/components/processTracking/imageLabel/imageLabelGalleryMultiple.component";
import ImageLabelFilter from "@/components/processTracking/imageLabel/imageLabelFilter.component";
import { ImageLabelData } from "@/types/Image.type";
import { FilterImagesLabel } from "@/types/imageLabel.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const typeShow = route.query.samplingPoint;
const showImagesLabelGallery = ref<boolean>(false);
const notSave = ref<boolean>(false);
const notShow = ref<boolean>(true);
const samplingPoints = ref<SamplingPoint[]>([]);
const camerasConfiguration = ref<CameraConfiguration[]>([]);
const dialogVisible = ref<boolean>(false);
const selectOptions = ref<{ label: string; value: number }>("");
const galleryKey = ref<number>(0);
const formFilter = ref<{
  samplingPoint?: SamplingPoint;
  fromDateTime?: Date;
  toDateTime?: Date;
  numberImageLabel?: number;
  cameras?: string[];
  showCameras?: string[];
  type: string;
}>({
  samplingPoint: undefined,
  fromDateTime: undefined,
  toDateTime: undefined,
  numberImageLabel: 4,
  type: "picture",
  cameras: [] as string[],
  showCameras: [] as string[],
});
const filterCmp = ref<InstanceType<typeof ImageLabelFilter> | null>(null);

const optionsImages = ref<FilterImagesLabel>({
  label: undefined,
  lighting_condition: undefined,
  estimations: undefined,
  training_data: undefined,
  type: undefined,
  origin: undefined,
  parameter: undefined,
  values: [undefined, undefined],
  relationStatus: undefined,
  onlyUnlabeled: false, // Filtro imágenes sin etiqueta
  modelTypology: undefined, // Tipología del modelo
  isDaytime: undefined, // Filtro imágenes de día
});

const arrayImages = ref<ImageLabelData[]>([]);
const arraySrc = ref<Record<string, string>>({});
const arrayCopyImages = ref<ImageLabelData[]>([]);
const arrayLabels = ref<ImageLabelData[]>([]);

const totalImagesFiltradas = ref(0);

const handleUpdateTotal = (total: number) => {
  totalImagesFiltradas.value = total;
};

const getImages = (
  images: ImageLabelData[],
  src: Record<string, string>,
  copy: ImageLabelData[],
  labels: ImageLabelData[]
) => {
  arrayImages.value = images;
  arraySrc.value = src;
  arrayCopyImages.value = copy;
  arrayLabels.value = labels;
};

onBeforeMount(async () => {
  const samplingPointId = route.query.samplingPoint;
  const sampResponse = await getSamplingPointsNoRelations(
    undefined,
    undefined,
    undefined,
    undefined,
    ["station"]
  );
  samplingPoints.value = sampResponse.data;
  formFilter.value.samplingPoint = samplingPoints.value.find((_) => _.id == samplingPointId);
  await getCameraConfiguration();
});
onMounted(async () => {
  //
});

const getCameraConfiguration = async () => {
  const samplingPointSelected = formFilter.value.samplingPoint;
  if (samplingPointSelected?.station?.id) {
    camerasConfiguration.value = await getCamerasConfigurationByStationId(
      samplingPointSelected.station.id
    );
  }

  formFilter.value.showCameras = [];
  camerasConfiguration.value.forEach((element: any) => {
    if (element.imageProcessingTime != null) {
      let type = "";
      if (element.imageProcessingTime !== "ALL_DAY") {
        type = ` (${element.imageProcessingTime})`;
        if (element.imageProcessingTime == "DAY") {
          formFilter.value.cameras[0] = element.camera.code;
        } else {
          formFilter.value.cameras[1] = element.camera.code;
        }
      } else {
        if (element.imageProcessingTime == "ALL_DAY") {
          formFilter.value.cameras[0] = element.camera.code;
        }
      }

      const name = element.camera.name;
      formFilter.value.showCameras.push(`${name}${type}`);
    }
  });

  if (formFilter.value.showCameras.length < 2) {
    formFilter.value.showCameras.push(`-`);
  }
};

const disabledData = (date: Date) => {
  return date.getTime() > Date.now(); // Deshabilitar fechas futuras
};

const changeBtnView = (type: string) => {
  formFilter.value.type = type;
  var blueBtn = document.getElementsByClassName("selected");
  if (blueBtn[0]) {
    blueBtn[0].className = blueBtn[0].className.replace("selected", "");
  }
  const btnDate = document.getElementById(type);
  btnDate?.classList.add("selected");
};

const showImagesForLabeling = () => {
  showImagesLabelGallery.value = true;
  notSave.value = false;
  notShow.value = true;
};

const filter = async () => {
  dialogVisible.value = true;
  const filter: Filter = {
    fields: {
      "tmoa.samplingPointId": {
        operator: "equal",
        value: formFilter.value.samplingPoint?.id,
      },
    },
  };

  const tmoas = await getTmoa(filter);
  if (tmoas) {
    selectOptions.value = tmoas.map((tmoa) => ({
      label: tmoa.name || tmoa.value?.toString(),
      value: tmoa.value,
    }));
  }
};

const applyFilters = () => {
  nextTick(() => {
    if (filterCmp.value && filterCmp.value.updateOptionsImage) {
      optionsImages.value = filterCmp.value.updateOptionsImage(true);
      totalImagesFiltradas.value = 0;
      dialogVisible.value = false;
      galleryKey.value++;
    } else {
      console.warn("filterCmp no está listo aún");
    }
  });
};

const cancel = () => {
  filterCmp.value.updateOptionsImage(false);
  dialogVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { style: {"width":"100%","height":"99vh"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "card-section first-card" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("title.imageLabel")), 1),
                _createVNode(_component_el_form, {
                  model: formFilter.value,
                  ref: "form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.monitorizationPoint")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "samplingPoint",
                      class: "full-width-item size"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formFilter.value.samplingPoint,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFilter.value.samplingPoint) = $event)),
                          "value-key": "id",
                          style: {"width":"100%"},
                          onChange: getCameraConfiguration,
                          disabled: "",
                          class: "sizeText"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodStartDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item size" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          "disabled-date": disabledData,
                          style: {"width":"100%"},
                          modelValue: formFilter.value.fromDateTime,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFilter.value.fromDateTime) = $event)),
                          type: "datetime",
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          disabled: _unref(typeShow) == 'view' || showImagesLabelGallery.value || !notShow.value,
                          class: "sizeText"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodEndDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item size" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          "disabled-date": disabledData,
                          style: {"width":"100%"},
                          modelValue: formFilter.value.toDateTime,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFilter.value.toDateTime) = $event)),
                          type: "datetime",
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          disabled: _unref(typeShow) == 'view' || showImagesLabelGallery.value || !notShow.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.numberImageLabel")), 1),
                    _createVNode(_component_el_form_item, {
                      class: "full-width-item size",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formFilter.value.numberImageLabel,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFilter.value.numberImageLabel) = $event)),
                          max: "6",
                          min: "1",
                          style: {"width":"100%"},
                          disabled: ""
                        }, {
                          "decrease-icon": _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowDown)
                              ]),
                              _: 1
                            })
                          ]),
                          "increase-icon": _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowUp)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.camera")) + "s", 1),
                    (camerasConfiguration.value && formFilter.value.samplingPoint && formFilter.value.showCameras)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFilter.value.showCameras, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, { key: index }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : (!camerasConfiguration.value && formFilter.value.samplingPoint)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No hay cámaras configuradas, pide al administrador que las configure. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_row, { class: "btn-view" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.$t('label.imageLabel'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          id: "picture",
                          class: "btn-view selected",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeBtnView('picture')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Picture)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.$t('label.imageLabel'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          id: "grid",
                          class: "btn-view",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (changeBtnView('grid')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Grid)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "size",
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showImagesForLabeling())),
                  disabled: 
              (!formFilter.value.samplingPoint || !formFilter.value.fromDateTime || !formFilter.value.toDateTime) &&
              (_unref(typeShow) == 'view' || notShow.value)
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.visualize")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 20 }, {
          default: _withCtx(() => [
            (showImagesLabelGallery.value)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: "main-content imagenes-wrapper"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          circle: "",
                          onClick: filter
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Operation)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (showImagesLabelGallery.value)
                          ? (_openBlock(), _createBlock(_component_el_text, {
                              key: 0,
                              type: "info",
                              size: "small",
                              class: "text"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createElementVNode("b", _hoisted_7, _toDisplayString(totalImagesFiltradas.value), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dialog, {
                      title: "Filtros de imágenes",
                      modelValue: dialogVisible.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event)),
                      width: "30%"
                    }, {
                      footer: _withCtx(() => [
                        _createVNode(_component_el_button, { onClick: cancel }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: applyFilters
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(ImageLabelFilter), {
                          ref_key: "filterCmp",
                          ref: filterCmp
                        }, null, 512)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (formFilter.value.type == 'picture')
                      ? (_openBlock(), _createBlock(_unref(ImagesLabelGallery), {
                          ref: "formCmp",
                          filters: formFilter.value,
                          images: arrayImages.value,
                          imagesrc: arraySrc.value,
                          copy: arrayCopyImages.value,
                          labels: arrayLabels.value,
                          filterImages: optionsImages.value,
                          onUpdateImages: getImages,
                          onUpdateTotal: handleUpdateTotal,
                          key: 'picture-' + galleryKey.value
                        }, null, 8, ["filters", "images", "imagesrc", "copy", "labels", "filterImages"]))
                      : (_openBlock(), _createBlock(_unref(ImagesLabelGalleryMultiple), {
                          ref: "multiple",
                          filters: formFilter.value,
                          images: arrayImages.value,
                          imagesrc: arraySrc.value,
                          copy: arrayCopyImages.value,
                          labels: arrayLabels.value,
                          filterImages: optionsImages.value,
                          onUpdateImages: getImages,
                          onUpdateTotal: handleUpdateTotal,
                          key: 'multiple-' + galleryKey.value
                        }, null, 8, ["filters", "images", "imagesrc", "copy", "labels", "filterImages"]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})